import { render, staticRenderFns } from "./WebsocketIntegration.vue?vue&type=template&id=73da54f8&scoped=true&"
import script from "./WebsocketIntegration.vue?vue&type=script&lang=ts&"
export * from "./WebsocketIntegration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73da54f8",
  null
  
)

export default component.exports